export default __webpack_public_path__ + "static/media/nftt.595ff129.gif";